// Production seller hosts and their per-host tracking config. Single source of
// truth for origin-based gating of third-party trackers (Hotjar, HubSpot), so
// loaders stay off on localhost and other non-production hosts.
const PRODUCTION_HOSTS = [
  { origin: "https://agencias.v3.mg-group.net.ar/", hotjarId: "1586788" },
  { origin: "https://web.agencias.mg-group.net.ar/", hotjarId: "1642652" },
  { origin: "https://app.mg-group.com.ar/", hotjarId: "1767938" },
  { origin: "https://app.v1.mg-group.com.ar/", hotjarId: "1776775" },
];

export const currentProductionHost = () =>
  PRODUCTION_HOSTS.find(({ origin }) => origin.includes(window.location.origin));

export const isProductionOrigin = () => Boolean(currentProductionHost());
